import React, { useEffect, useState } from 'react';
import { Box, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { TEXT_COLORS } from '../../utils/colors';

export interface SearchFieldProps {
  /** Применённое значение (из URL/state родителя); при его смене снаружи (сброс) поле подхватывает его */
  value: string;
  /** Вызывается ТОЛЬКО по Enter — с обрезанным текстом; пустая строка = снять фильтр */
  onSearch: (value: string) => void;
  placeholder: string;
}

/**
 * Поле поиска по Enter для строки фильтров (docs/ui-patterns.md §1).
 * `React.memo` + свой state текста: печать не ре-рендерит страницу, запрос уходит только по Enter.
 */
export const SearchField: React.FC<SearchFieldProps> = React.memo(({ value, onSearch, placeholder }) => {
  const [input, setInput] = useState(value);

  useEffect(() => { setInput(value); }, [value]);

  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        onSearch(input.trim());
      }}
      sx={{ display: 'flex', flex: { xs: 1, sm: '0 1 220px' }, minWidth: { xs: 0, sm: 180 } }}
    >
      <TextField
        fullWidth
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder={placeholder}
        variant="outlined"
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: TEXT_COLORS.MUTED, fontSize: 20 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiInputBase-root': { height: '100%' },
          '& .MuiInputBase-input': { py: 0.75, fontSize: { xs: '0.8rem', sm: '0.875rem' } },
        }}
      />
    </Box>
  );
});

SearchField.displayName = 'SearchField';

export default SearchField;
